import {IconInfo} from "./IconInfo";
import {$t} from "../lang/LangUtil";
import {Theme} from "@ice/components";
import {css, jsx} from "@emotion/core";
import {XIcon} from "../ui/XIcon";


export class GuiUtil {

    static renderToolbarIcon = (
        iconInfo: IconInfo,
        tooltip?: string,
        onClick?: () => void,
        isOff: boolean = false
    ): JSX.Element => {
        return (
            <XIcon
                icon={iconInfo}
                iconSize={"1.25em"}
                title={tooltip}
                onClick={onClick}
                css={(theme: Theme) => css`
                      fill: ${isOff ? theme.textColor.disabled : theme.focusAndAccentColor};
                      cursor: pointer;
                      &:hover {
                        fill: ${isOff ? theme.textColor.disabled : theme.selectionColor};
                      }
                    `}
            />
        )
    }

}